import { getChartsData } from './chartDataGenerators/getChartsData';
import { getFilteredRequests } from './getFilteredRequests';
import { filterNames } from '../constants/filterNames';
import { statisticsPages } from '../../../constants/statisticsPages';
import { initRequestsCounts } from '../constants/common';

export const getStatisticsData = ({
  requests = [],
  filterValues = {},
  page,
}) => {
  const filteredRequests = getFilteredRequests({
    requests,
    filterValues,
  });

  const chartsData = getChartsData(filteredRequests);

  const chartsRequests = {
    [filterNames.masters]: chartsData.masters,
    [filterNames.executers]: chartsData.executers,
    [filterNames.parentServices]: page ? chartsData.parentServices : [],
    [filterNames.services]: page ? chartsData.services : [],
    [filterNames.houses]: page ? chartsData.houses : [],
    [filterNames.marks]: page ? chartsData.marks : [],
    [filterNames.regions]: page ? chartsData.regions : [],
    [filterNames.ratings]:
      page === statisticsPages.lifetime ? chartsData.ratings : [],
    requestsByDate: page ? [] : chartsData.requestsByDate,
  };

  return {
    filteredRequests: filteredRequests,
    requestsCounts: page ? initRequestsCounts : chartsData.requestsCounts,
    chartsRequests,
  };
};
